module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-classic-4-0f5bcc6292125c0021d37a67701dc6cd.webp";